import { StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

export default StyleSheet.create({
    debugWrapper: {
        position: 'absolute',
        left: 0,
        top: 0,
        backgroundColor: '#ace5f8',
    },
    buttonWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 10

    },
    inputText: {
        height: 40, 
        borderColor: 'gray',
        borderWidth: 1,
        width: width 
    }
})